import * as React from 'react';
import type { SVGProps } from 'react';
const SvgZip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#Zip_svg__a)">
      <path d="M10.182 10.041H8.148V8.685h2.034z" />
      <path d="M12.14 8.828h-2.034V7.47h2.034zm.077 2.568h-2.034V10.04h2.034zm-2.035 1.358H8.148v-1.357h2.035zm2.035 1.356h-2.034v-1.356l2.034-.001zm-2.035 1.356H8.148v-1.357h2.035zm2.035 1.357h-2.034v-1.357h2.034zm-2.035 1.357H8.148v-1.357h2.035zm2.345-15.666a.51.51 0 0 0-.518-.607H8.203a.537.537 0 0 0-.518.607l.181 3.541c.052.254.26.405.518.405h3.495c.26 0 .466-.151.518-.405zm-2.395 2.429c-.57 0-1.037-.456-1.037-1.012 0-.557.466-1.012 1.037-1.012.57 0 1.036.455 1.036 1.012s-.466 1.012-1.036 1.012" />
    </g>
    <defs>
      <clipPath id="Zip_svg__a">
        <path d="M18 18.3H1.001V1.301H18z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgZip;
